import React from "react";
import {observer, inject} from "mobx-react";


@inject("store")
@observer
export default class DoctypeMall extends React.Component {

    // model props
    constructor(props) {
        super(props);

        //this.ref = Math.random().toString(36).substr(2, 9);
    }

    getCropUrl(image, alias) {
        let imageSrc = image.mediaKey;

        let cropUrl = imageSrc + "?mode=crop&cropmode=percentage";
        const gifImage = image.mediaKey && image.mediaKey.toLowerCase().endsWith(".gif");
        const crop = image.crops.find(x => x.alias == alias);

        if (crop) {
            if (crop.coordinates) {
                cropUrl += "&crop=" +
                    crop.coordinates.x1 +
                    "," +
                    crop.coordinates.y1 +
                    "," +
                    crop.coordinates.x2 +
                    "," +
                    crop.coordinates.y2;
            }
            
            
            if(!gifImage) { // Don't resize gif images to avoid large files from upscaling
                if (crop.width) {
                    cropUrl += "&width=" + crop.width;
                }
    
                if (crop.height) {
                    cropUrl += "&height=" + crop.height;
                }
            }
        }

        if(gifImage) { // don't switch format for gif images to avoid losing animations
            cropUrl += "&format=gif";
        } else {
            cropUrl += "&format=webp";// + navigation.ImageFormat;
            cropUrl += "&quality=60";
        }

        return cropUrl;
    }


    renderContent() {

        const model = this.props.model;
        const templatePair = model.template && model.template.split(" - ");
        const template = templatePair && templatePair.length > 0 && templatePair[0] || "Mall 1";
        const target = model && model.link && Array.isArray(model.link) && model.link.length > 0 ? model.link[0].target : "";


        const mobileImage = model.mobileImage && this.props.model.mobileImage[0];
        const desktopImage = model.desktopImage && this.props.model.desktopImage[0];
        const mobileCrop = model.mobileCrop || "square";
        const desktopCrop = model.desktopCrop || "landscape";

        var mobileCropInfo = mobileImage && mobileImage.crops && mobileImage.crops.find(x => x.alias === mobileCrop);
        var desktopCropInfo = desktopImage && desktopImage.crops && desktopImage.crops.find(x => x.alias === desktopCrop);
        var mobileImageUrl = mobileImage && this.getCropUrl(mobileImage, mobileCrop);
        var desktopImageUrl = desktopImage && this.getCropUrl(desktopImage, desktopCrop);

        const ctaColour = model.fargPaCTA.toLowerCase() || "svart";

        const url = (Array.isArray(model.link) && model.link.length > 0 ? model.link[0].url : model.link);

        //console.log("model", model);

        if (!(mobileCropInfo && desktopCropInfo && mobileImage && desktopImage)) {
            return;
        } 

        switch (template) {

            case "Mall 1":
                return [
                     <div key={"mobile"} className={"hidden-md-up"}>
                        <img
                            width={mobileCropInfo && mobileCropInfo.width || null}
                            height={mobileCropInfo && mobileCropInfo.height || null}
                            src={mobileImageUrl} 
                            alt={model.mobileHeader}
                            loading="lazy"
                        />
                        {model.mobileHeader &&
                            <div className="cta-header" style={{position: "absolute", left: 0, right: 0, bottom: 0}}>
                                <h2 style={{textAlign: "center"}}>{model.mobileHeader}</h2>
                                {model.callToAction && url &&
                                    <div className="cta-header-button" style={{textAlign: "center"}}>
                                        <a href={url}  target={target}  title={model.callToAction} className={"cta-button " + ctaColour}>{model.callToAction}</a></div>
                                }
                            </div>

                        }

                    </div>,

                    <div key={"desktop"} className={"hidden-sm-down"}>
                        <img
                            width={desktopCropInfo && desktopCropInfo.width || null}
                            height={desktopCropInfo && desktopCropInfo.height || null}
                            src={desktopImageUrl} 
                            alt={model.desktopHeader}
                            loading="lazy"
                        />
                        {model.desktopHeader &&
                            <div className="cta-header" style={{position: "absolute", left: 0, right: 0, bottom: 0}}>
                                <h2 style={{textAlign: "center"}}>{model.desktopHeader}</h2>
                                {model.callToAction && url &&
                                    <div className="cta-header-button" style={{textAlign: "center"}}>
                                        <a href={url}  target={target} title={model.callToAction} className={"cta-button " + ctaColour}>{model.callToAction}</a></div>
                                }
                            </div>

                        }
                    </div>
                ];
            case "Mall 2":
            case "Mall 3":
                const colWidth = template === "Mall 2" ? "col-6" : "col-12";
                return [
                    <div key={"mobile"} className={"hidden-lg-up"}>
                        <div>
                            <img
                                width={mobileCropInfo && mobileCropInfo.width || null}
                                height={mobileCropInfo && mobileCropInfo.height || null}
                                src={mobileImageUrl} className={"hidden-lg-up"}
                                alt={model.mobileHeader}
                                loading="lazy"
                            />
                        </div>
                        {model.text &&
                            <div style={{aspectRatio: mobileCropInfo.width + " / " + mobileCropInfo.height}} className={"d-flex justify-content-center align-items-center"}>
                                <div className={""} style={{maxWidth: 600, padding: "30px"}}>
                                    <h1 style={{color: "#f4ca01"}}>{model.mobileHeader}</h1>
                                    <p>{model.text}</p>
                                    {model.callToAction && url &&
                                        <div className="cta-header-button" style={{textAlign: "center"}}>
                                            <a href={url}  target={target} title={model.callToAction} className={"cta-button " + ctaColour}>{model.callToAction}</a></div>
                                    }
                                </div>
                            </div>

                        }

                    </div>,

                    <div key={"desktop"} className={"hidden-md-down row"}>
                        <div className={colWidth}>
                            <div>
                                <img
                                    width={desktopCropInfo && desktopCropInfo.width || null}
                                    height={desktopCropInfo && desktopCropInfo.height || null}
                                    src={desktopImageUrl} className={"hidden-sm-down"}
                                    alt={model.desktopHeader}
                                    loading="lazy"
                                /></div>
                        </div>
                        {model.text &&
                            <div className={colWidth}>
                                <div style={{aspectRatio: desktopCropInfo.width + " / " + desktopCropInfo.height}} className={"d-flex justify-content-center align-items-center"}>
                                    <div className={""} style={{maxWidth: 800, padding: "50px"}}>
                                        <h1 style={{color: "#f4ca01"}}>{model.desktopHeader}</h1>
                                        <p>{model.text}</p>
                                        {model.callToAction && url &&
                                            <div className="cta-header-button" style={{textAlign: "center"}}>
                                                <a href={url}  target={target} title={model.callToAction} className={"cta-button " + ctaColour}>{model.callToAction}</a></div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                ];
            case "Mall 4":
                return [
                    <div key={"mobile"} className={"hidden-lg-up"}>
                        <div>
                            <img
                                width={mobileCropInfo && mobileCropInfo.width || null}
                                height={mobileCropInfo && mobileCropInfo.height || null}
                                src={mobileImageUrl} className={"hidden-lg-up"}
                                alt={model.mobileHeader}
                                loading="lazy"
                            />
                        </div>
                        {model.mobileHeader &&
                            <h6>{model.mobileHeader}</h6>
                        }

                    </div>,

                    <div key={"desktop"} className={"hidden-md-down"}>
                        <div>
                            <img
                                width={desktopCropInfo && desktopCropInfo.width || null}
                                height={desktopCropInfo && desktopCropInfo.height || null}
                                src={desktopImageUrl} className={"hidden-sm-down"}
                                alt={model.desktopHeader}
                                loading="lazy"
                            />
                        </div>
                        {model.desktopHeader &&
                            <h6>{model.desktopHeader}</h6>
                        }

                    </div>
                ];

        }
    }

    render() {
        // if (!this.props.model.images) {
        //     return (null);
        // }

        const model = this.props.model;
        const url = model && model.link && Array.isArray(model.link) && model.link.length > 0 ? model.link[0].url : model.link;
        const target = model && model.link && Array.isArray(model.link) && model.link.length > 0 ? model.link[0].target : "";

        return (<div className="doc-type-mall"
                     onClick={(e) => this.props.store.navigation.aHrefNavigation(e)}
        >
            {model.link
                
                // ? <div className={"Box has-link"} onClick={(c) => {
                //    
                //     this.props.store.navigation.navigateToSiteUrl(null, url);
                // }}>
                ? <div className={"Box"}>
                    <a className={"overlay"} href={url} target={target}></a>
                    <div className={"inner"}>
                    {this.renderContent()}
                        </div>
                </div>
                : <div className={"Box"}>
                    {this.renderContent()}
                </div>
            }


            {/*<pre>{JSON.stringify(this.props.model, undefined, 2)}</pre>*/}
        </div>);

    }


}